

/**
 * Accesses enviroment variable and throws error if its missing
 * @param variableName
 * @returns 
 */
export const getRequiredEnviromentVariable = (variableName: string): string => {
    const variable = process.env[variableName];
    if (!variable) {
        throw new Error(`[env]: ${variableName} must be defined"`);
    };
    return variable
};

/**
 * Converts enviroment variable to boolean
 * @param variableName 
 * @returns 
 */
export const getBooleanEnviromentVariable = (variableName: string): boolean | undefined => {
    const variable = process.env[variableName];
    return variable ? variable === "true" : undefined
};


const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
/**
 * Returns true if base url constains word test
 */
export const bestGuessHostedInDevelopment = BASE_URL.indexOf("test") > -1 && BASE_URL.indexOf("prod") === -1;

